import { HistoricalWorkItem } from "@buzzeasy/shared-frontend-utilities";
import { createApi } from "@reduxjs/toolkit/query/react";
import { buildWorkItemQueryString, odataBaseQuery, ODataListResult, WorkItemFilters } from "../queryHelpers";
import authSlice, { AuthInfo } from "../slices/authSlice";

const historicalDataApi = createApi({
  reducerPath: "historicalDataApi",
  tagTypes: ["WorkItems"],
  baseQuery: odataBaseQuery(),
  endpoints: builder => ({
    searchWorkItems: builder.query<{ total: number; workItems: HistoricalWorkItem[] }, WorkItemFilters>({
      queryFn: async (params, api, _, baseQuery) => {
        const agentId = (api.getState() as { [authSlice.name]: AuthInfo }).auth.user.id;
        const result = await baseQuery(`/v1/workItems${buildWorkItemQueryString(agentId, params)}`);

        if (result.error) {
          return { error: result.error };
        }

        const data = result.data as ODataListResult<HistoricalWorkItem>;
        return {
          data: {
            total: data["@odata.count"] ?? 0,
            workItems: data.value ?? [],
          },
        };
      },

      providesTags: params => [{ type: "WorkItems", id: JSON.stringify(params) }],
    }),
  }),
});

export const { useSearchWorkItemsQuery } = historicalDataApi;

export default historicalDataApi;
